<template>
  <div>
    <v-menu offset-y v-if="$vuetify.breakpoint.smAndUp">
      <template v-slot:activator="{ on }">
        <v-btn color="primary" dark text v-on="on" class=" pl-2">
          {{selectedlanguage}}
          <li v-for="language in languages" :key="language.short">
            <div v-if="selectedlanguage == language.short" >
              <v-btn disabled :outlined="selectedlanguage == language.short" @click="changelanguage(language.short)">
                <div :style="{width: iconsize, height: '1.5em'}" :class="`flag-icon-${language.icon}`"></div>
              </v-btn>
            </div>
          </li>
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          v-for="language in languages" :key="language.short">
          <v-btn icon class="pl-8" @click="changelanguage(language.short)">
            <div :style="{width: iconsize, height: '1.5em'}" :class="`flag-icon-${language.icon}`"></div>
            <span class="title pl-3">
              {{language.short}}
            </span>
          </v-btn>
        </v-list-item>
      </v-list>
    </v-menu>
    <!--Phone-->
    <v-menu offset-y v-else>
      <template v-slot:activator="{ on }">
        <v-btn color="primary" dark text v-on="on" class="ma-0 pa-0">
          <li v-for="language in languages" :key="language.short">
            <div v-if="selectedlanguage == language.short" >
              <v-btn class="ma-0 pa-0" icon disabled :outlined="selectedlanguage == language.short" @click="changelanguage(language.short)">
                <div :style="{width: iconsize, height: '1.5em'}" :class="`flag-icon-${language.icon}`"></div>
              </v-btn>
            </div>
          </li>
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          v-for="language in languages" :key="language.short">
          <v-btn icon @click="changelanguage(language.short)">
            <div :style="{width: iconsize, height: '1.5em'}" :class="`flag-icon-${language.icon}`"></div>
          </v-btn>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
// Function imported from vuex
import { mapGetters, mapActions } from "vuex";
import "@/assets/flag-icon.css";
export default {
  data() {
    return {
      languagePicked:"",
      iconsize: "2em",
      languages: [{ short: "nb", icon: "no" }, { short: "en", icon: "gb" }, { short: "es", icon: "es" }, { short: "bg", icon: "bg" }],
      selectedlanguage: localStorage.getItem("setlanguage") || "en"
    };
  },
  methods: {
    changelanguage(newlang) {
      this.$root.changeLocale(newlang);
      this.selectedlanguage = newlang;
    }
  },
  watch: {
    getLang(newLocale) {
      this.selectedlanguage = newLocale;
    }
  },
  computed: {
    ...mapGetters(["isLoggedIn", "fullName", "updateStatus", "getLang"])
  }
};
</script>

<style scoped>
li {
  display: block;
  flex: 0 1 auto; /* Default */
  list-style-type: none;
  align-self: center;
}

li:last-child {
  margin-right: 0;
}
li a {
  text-decoration: none;
  color: inherit;
}
</style>